import { render, staticRenderFns } from "./CardContactClient.vue?vue&type=template&id=81b13dae"
import script from "./CardContactClient.vue?vue&type=script&lang=js"
export * from "./CardContactClient.vue?vue&type=script&lang=js"
import style0 from "./CardContactClient.vue?vue&type=style&index=0&id=81b13dae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports